module.exports = __webpack_public_path__ + "img/square-question-duotone.793b5aec.svg";